import { render, staticRenderFns } from "./communicationDashboardPrintGenerator.vue?vue&type=template&id=59f444f9&scoped=true"
import script from "./communicationDashboardPrintGenerator.vue?vue&type=script&lang=js"
export * from "./communicationDashboardPrintGenerator.vue?vue&type=script&lang=js"
import style0 from "./communicationDashboardPrintGenerator.vue?vue&type=style&index=0&id=59f444f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f444f9",
  null
  
)

export default component.exports